import { DataGrid as MuiDataGrid, DataGridProps } from '@mui/x-data-grid';
import { Box, Typography } from '@mui/material';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import NoRowsImg from '@assets/global/noRows.png';
import { useTranslation } from 'react-i18next';

interface Props extends DataGridProps {
  boxSx?: SxProps<Theme>;
  currentPage: number;
}

const CustomNoRowsOverlay = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img src={NoRowsImg} alt="no rows" width={100} />
      <Typography mt={2} sx={{ color: '#919394' }}>
        {t('The list is currently empty.')}
      </Typography>
    </Box>
  );
};

export function DataGrid(props: Props) {
  const { sx, boxSx, getRowClassName, ...others } = props;
  const { t } = useTranslation();
  const PAGE_SIZE: number = 30;
  return (
    <Box sx={{ bgcolor: '#fff', boxShadow: 1, borderRadius: 2, ...boxSx }}>
      <MuiDataGrid
        sx={{ minHeight: 700, height: '100%', ...sx }}
        paginationMode="server"
        pagination
        paginationModel={{
          pageSize: PAGE_SIZE,
          page: props.currentPage,
        }}
        pageSizeOptions={[]}
        // hideFooter
        disableColumnSelector={true}
        disableColumnMenu={true}
        localeText={{
          MuiTablePagination: {
            labelDisplayedRows: ({ from, to, count }) =>
              `${from} - ${to} ${t('of')} ${count}`,
          },
        }}
        slots={{
          noRowsOverlay: CustomNoRowsOverlay,
        }}
        getRowClassName={getRowClassName}
        {...others}
      />
    </Box>
  );
}
